import React from "react";

import attachFile from "../../assets/icons/attach_file.svg";

export default function FileInput({ file, onChange, id }) {
  return (
    <div className="max-w-[150px] pr-3">
      <input
        type="file"
        className="hidden"
        id={id}
        onChange={(e) => onChange(e.target.files?.[0])}
      />
      <label
        htmlFor={id}
        className="flex items-center justify-between gap-2 cursor-pointer"
      >
        <span className="w-full flex-1 block p-2 py-1 px-4 bg-transparent text-[#242424] text-[14px] font-normal rounded-[4px] border border-[#232633] shadow-[2px_2px_5px_0_rgba(0,_39,_81,_0.25)_inset] text-center overflow-hidden whitespace-nowrap text-ellipsis min-w-[82px]">
          {file?.name || "Select"}
        </span>
        <img src={attachFile} alt="attach" className="" />
      </label>
    </div>
  );
}
